import React, { FC, PropsWithChildren } from 'react';
import { useInstantSearch } from 'react-instantsearch';

type LoadGuardProps = {
  noResultsMessage: React.ReactNode;
};

export const LoadGuard: FC<PropsWithChildren<LoadGuardProps>> = ({ children, noResultsMessage }) => {
  const { status, results } = useInstantSearch();

  if (status === 'loading' || status === 'stalled') {
    return <div>{theme.locales.accessibility.loading}</div>;
  }

  if (results.nbHits === 0) {
    return noResultsMessage;
  }

  return children;
};
